export default __webpack_public_path__ + "static/media/11n.4f4036a2.png";